var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Dialog, DialogHeader, Dimmer, Scrollbars, Styler } from '@honeycomb/ui-core';
import { pushMapPinClick, pushMapPopoverCardClose } from '@honeycomb/tracking';
import { HotelMapPopoverCard } from '../../content/Map/HotelMapPopOverCard';
import { InteractiveMap } from '../../content/Map/InteractiveMap';
import { MapMarkerCollection } from '../../content/Map/MapMarkerCollection';
import { MapInfoWindow } from '../../content/Map/MapInfoWindow';
import { MapMarker } from '../../content/Map/MapMarker';
import { useHotelSearchResultsTitle } from '../utils';
const SIDEBAR_COLUMN_WIDTH = '320px';
export function HotelSearchResultsMapDialog(_a) {
    var _b;
    var { hotels, filteredHotelCount, filtersContent, filtersButton, onClose, loading } = _a, other = __rest(_a, ["hotels", "filteredHotelCount", "filtersContent", "filtersButton", "onClose", "loading"]);
    const [selectedHotel, setSelectedHotel] = useState(null);
    const selectedEstabId = selectedHotel === null || selectedHotel === void 0 ? void 0 : selectedHotel.hotel.estabId;
    const title = useHotelSearchResultsTitle(filteredHotelCount, loading);
    const handlePopupClose = () => {
        setSelectedHotel(null);
        pushMapPopoverCardClose();
    };
    const handleMapMarkerClick = (hotel) => {
        setSelectedHotel((currentSelected) => ((currentSelected === null || currentSelected === void 0 ? void 0 : currentSelected.hotel.estabId) === hotel.hotel.estabId ? null : hotel));
        pushMapPinClick(hotel.hotel);
    };
    const markers = React.useMemo(() => {
        if (!hotels) {
            return [];
        }
        return hotels.map((hotel) => {
            var _a, _b, _c, _d;
            const lat = (_b = (_a = hotel.hotel.geography) === null || _a === void 0 ? void 0 : _a.latitude) !== null && _b !== void 0 ? _b : 0;
            const lng = (_d = (_c = hotel.hotel.geography) === null || _c === void 0 ? void 0 : _c.longitude) !== null && _d !== void 0 ? _d : 0;
            const selected = selectedEstabId === hotel.hotel.estabId;
            return (React.createElement(MapMarker, { key: `map-marker-${hotel.hotel.estabId}`, coordinates: { lat, lng }, title: hotel.hotel.name, pricingSummary: hotel.pricingSummary, selected: selected, onClick: () => {
                    handleMapMarkerClick(hotel);
                }, estabId: hotel.hotel.estabId }));
        });
    }, [hotels, selectedEstabId]);
    return (React.createElement(Dialog, Object.assign({ fullScreen: "always", onClose: () => {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            handlePopupClose();
        } }, other),
        React.createElement(DialogHeader, { withCloseButton: true }, title),
        React.createElement(Styler, { display: "flex", flexDirection: "row", overflow: "hidden", h: "100%" },
            filtersContent && (React.createElement(Scrollbars, { w: SIDEBAR_COLUMN_WIDTH, mah: "100%", bg: "background.offset", p: 6, pr: 2 }, filtersContent)),
            React.createElement(Styler, { flexGrow: 1, overflowY: "hidden", pos: "relative" },
                filtersButton && (React.createElement(Styler, { pos: "absolute", p: 3, top: 0, zIndex: 1 }, filtersButton)),
                React.createElement(InteractiveMap, { zoomControl: true },
                    React.createElement(MapMarkerCollection, null, markers),
                    React.createElement(MapInfoWindow, { visible: selectedHotel != null, onClosed: handlePopupClose }, selectedHotel && (React.createElement(HotelMapPopoverCard, { key: selectedHotel.hotel.estabId, handlePopupClose: handlePopupClose, staticDetails: selectedHotel.hotel, pricingSummary: selectedHotel.pricingSummary, hasFlight: Boolean((_b = selectedHotel === null || selectedHotel === void 0 ? void 0 : selectedHotel.flight) === null || _b === void 0 ? void 0 : _b.flightDetailsId) })))),
                React.createElement(Dimmer, { active: loading, loading: loading, LoaderProps: { color: 'primary.base' } })))));
}
